export type ParseResult = { value: number } | { error: string };

export function parseNumber(input: string, label = 'Value'): ParseResult {
  const trimmed = (input ?? '').trim();
  if (!trimmed) return { error: `${label} is required` };

  // allow user-entered thousands separators
  const normalized = trimmed.replace(/,/g, '');
  const value = Number(normalized);
  if (!Number.isFinite(value)) return { error: `${label} must be a valid number` };
  return { value };
}

export function requireNonNegative(value: number, label: string): ParseResult {
  if (value < 0) return { error: `${label} cannot be negative` };
  return { value };
}

export function requirePositive(value: number, label: string): ParseResult {
  if (value <= 0) return { error: `${label} must be greater than zero` };
  return { value };
}

export function round(value: number, decimals = 2): number {
  const p = Math.pow(10, decimals);
  return Math.round((value + Number.EPSILON) * p) / p;
}

export function ft2ToM2(ft2: number): number {
  return ft2 * 0.09290304;
}

export function m2ToFt2(m2: number): number {
  return m2 / 0.09290304;
}

export function ft3ToM3(ft3: number): number {
  return ft3 * 0.028316846592;
}

export function m3ToFt3(m3: number): number {
  return m3 / 0.028316846592;
}

export function calcCfmFromAch(volumeFt3: number, ach: number): number {
  // CFM = (V * ACH) / 60
  if (!Number.isFinite(volumeFt3) || !Number.isFinite(ach)) return NaN;
  if (volumeFt3 <= 0) return NaN;
  if (ach < 0) return NaN;
  return (volumeFt3 * ach) / 60;
}

export function calcAchFromCfm(volumeFt3: number, cfm: number): number {
  // ACH = (CFM * 60) / V
  if (!Number.isFinite(volumeFt3) || !Number.isFinite(cfm)) return NaN;
  if (volumeFt3 <= 0) return NaN;
  if (cfm < 0) return NaN;
  return (cfm * 60) / volumeFt3;
}
